<template>
    <div id="app" :class="{ mobile: isMobile }">
      <transition enter-class="opacity-0" enter-active-class="ease-in" enter-to-class="opacity-100" leave-class="opacity-100" leave-active-class="ease-out duration-300" leave-to-class="opacity-0">
    <div class="fixed inset-0 min-w-full min-h-screen z-50 bg-white transition-opacity" v-if="showSlide && started">
        <b-carousel :autoplay="false">
            <b-carousel-item v-for="(slide, i) in slides" :key="i">
            <div class="min-h-screen flex flex-col p-4" :style="`background: url('${slide.Background}'); background-size: cover`">
                <div class="flex justify-end">
                <img :src="slide.Logo" width="100px"/>
                </div>
                <div class="flex-1 flex flex-col justify-center items-center ">
                <img :src="slide.Image" class="w-1/2" />
                <p class="text-center w-1/2">{{slide.Text}}</p>
                <b-button v-if="slide.Button" :type="slide.Button.Type" class="mt-4 w-full" @click="closeSlide">{{slide.Button.Text}}</b-button>
                </div>
            </div>
        </b-carousel-item>
        </b-carousel>
    </div>
  </transition>
      <router-view v-if="started"></router-view>
    </div>
</template>
<script>
import socket from './mixin/socket'
import BaseApp from './BaseApp'
export default {
  extends: BaseApp,
  mixins: [socket],
  data () {
    return {
      started: false,
      showSlide: false,
      slides: []
    }
  },
  methods: {
    async init () {
      const loading = this.$buefy.loading.open()
      try {
        this.$store.dispatch('webcontent/loadFromCache')
        await Promise.all([
          this.getCompany(),
          // preload content
          // this.$store.dispatch('webcontent/get', { path: '/home' }),
          this.$store.dispatch('webcontent/get', { path: '/login' }),
          this.$store.dispatch('webcontent/get', { path: '/register' })
        ])
        if (this.user.IsLogin) {
          this.onesignallogin()
          this.$store.dispatch('socket/getNotification')
        }
        this.showSlide = !localStorage.getItem('init') && this.isCordova
        // this.showSlide = !localStorage.getItem('init')
        this.slides = this.company.Intro
        this.started = true
      } catch (err) {
        alert(err.message)
      } finally {
        loading.close()
      }
    },
    closeSlide () {
      this.showSlide = false
      localStorage.setItem('init', 1)
    }
  },
  mounted () {
    this.init()
  }
}
</script>
